"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLoanTapeTypeMap = exports.ensureNoDuplicateDependencies = exports.removeDependencies = exports.removeDependency = exports.removeArtifactsByTypes = exports.removeDependenciesByOutputArtifactId = exports.removeDependenciesByInputArtifactId = exports.insertDependency = exports.getDependency = exports.filterUserInputNeededNodesCashBalanceContext = exports.filterUserInputNeededNodesForAssignment = exports.getOutputTapes = exports.getDependenciesByInputId = exports.getAllDependencyInputTapes = exports.getInputTapes = exports.getDependenciesByOutputId = exports.filterApprovalReports = exports.filterFundingRequests = exports.filterCashBalancesFeedContexts = exports.filterManualBankAccountReports = exports.filterCashResponseTapes = exports.filterInternalRepaymentTapes = exports.filterAssignedRepaymentTapes = exports.filterGeneratedRepaymentTapes = exports.filterGeneratedCashBalanceFeeds = exports.filterBorrowingBaseReports = exports.filterReceivableResponseTapePreviews = exports.filterAssignedLoanTapes = exports.filterReceivableResponseTapes = exports.filterMasterLoanTapes = exports.filterReceivableInvoiceTapes = exports.filterReceivableDocumentationVerificationReportTapes = exports.filterGeneratedLoanTapes = exports.filterGeneratedCovenantLoanTapes = exports.findOptionalArtifactBySlug = exports.findArtifactBySlugAndValidateLp = exports.findArtifactBySlug = exports.findArtifactById = exports.parseArtifactDocumentId = exports.hasLoanProductSlug = exports.hasCreditFacilitySlug = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const typeguards = __importStar(require("../typeguards"));
const { cloneDeep, isArray, every, isString } = lodash_1.default;
const hasCreditFacilitySlug = (artifacts) => {
    return (isArray(artifacts) &&
        every(artifacts, (artifact) => isString(artifact.creditFacilitySlug)));
};
exports.hasCreditFacilitySlug = hasCreditFacilitySlug;
const hasLoanProductSlug = (artifacts) => {
    return every(artifacts, (artifact) => isString(artifact.loanProductSlug));
};
exports.hasLoanProductSlug = hasLoanProductSlug;
const parseArtifactDocumentId = (dataTapes) => {
    const artifactDocumentIds = (0, remeda_1.pipe)(dataTapes, (0, remeda_1.map)(({ artifactDocumentId }) => artifactDocumentId), (0, remeda_1.uniq)());
    (0, common_1.finleyAssert)(artifactDocumentIds.length === 1, 'artifactDocumentId must be unique');
    return artifactDocumentIds[0];
};
exports.parseArtifactDocumentId = parseArtifactDocumentId;
const findArtifactById = ({ artifactId, dataTapes, }) => {
    const filterDataTapes = (0, remeda_1.filter)(dataTapes, ({ id }) => id === artifactId);
    (0, common_1.finleyAssert)(filterDataTapes.length === 1, `single [artifactId:${artifactId}] not found. [Found:${filterDataTapes.length}]`);
    return filterDataTapes[0];
};
exports.findArtifactById = findArtifactById;
const findArtifactBySlug = ({ artifactSlug, dataTapes, }) => {
    const filterDataTapes = (0, remeda_1.filter)(dataTapes, (tape) => tape.artifactSlug === artifactSlug);
    (0, common_1.finleyAssert)(filterDataTapes.length === 1, `Expected to find single artifact, but found [count:${filterDataTapes.length}] for [artifactSlug:${artifactSlug}]`);
    return filterDataTapes[0];
};
exports.findArtifactBySlug = findArtifactBySlug;
const findArtifactBySlugAndValidateLp = (inputs) => {
    const { artifactSlug, dataTapes, loanProductSlug } = inputs;
    const targetArtifact = (0, exports.findArtifactBySlug)({ dataTapes, artifactSlug });
    (0, common_1.finleyAssert)(targetArtifact.loanProductSlug === loanProductSlug, `Mismatched loan product artifact [artifactSlug:${artifactSlug}] [targetLpSlug:${loanProductSlug}] [foundLpSlug:${targetArtifact.loanProductSlug}]`);
    return targetArtifact;
};
exports.findArtifactBySlugAndValidateLp = findArtifactBySlugAndValidateLp;
const findOptionalArtifactBySlug = (params) => {
    const { artifactSlug, dataTapes } = params;
    const filterDataTapes = dataTapes.filter((tape) => tape.artifactSlug === artifactSlug);
    (0, common_1.finleyAssert)(filterDataTapes.length <= 1, `Expected to find 0 or 1 target artifact, found ${filterDataTapes.length} for [artifactSlug:${artifactSlug}]`);
    return filterDataTapes[0] ?? null;
};
exports.findOptionalArtifactBySlug = findOptionalArtifactBySlug;
const filterArtifactsByType = ({ dataTapes, type, }) => dataTapes.filter((tape) => tape.type === type);
const filterGeneratedCovenantLoanTapes = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'generatedCovenantLoanTape' });
exports.filterGeneratedCovenantLoanTapes = filterGeneratedCovenantLoanTapes;
const filterGeneratedLoanTapes = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'generatedLoanTape' });
exports.filterGeneratedLoanTapes = filterGeneratedLoanTapes;
const filterReceivableDocumentationVerificationReportTapes = ({ dataTapes, }) => filterArtifactsByType({
    dataTapes,
    type: 'receivableDocumentationVerificationReport',
});
exports.filterReceivableDocumentationVerificationReportTapes = filterReceivableDocumentationVerificationReportTapes;
const filterReceivableInvoiceTapes = ({ dataTapes, }) => filterArtifactsByType({
    dataTapes,
    type: 'receivableInvoice',
});
exports.filterReceivableInvoiceTapes = filterReceivableInvoiceTapes;
const filterMasterLoanTapes = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'masterLoanTape' });
exports.filterMasterLoanTapes = filterMasterLoanTapes;
const filterReceivableResponseTapes = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'receivableResponseTape' });
exports.filterReceivableResponseTapes = filterReceivableResponseTapes;
const filterAssignedLoanTapes = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'assignedLoanTape' });
exports.filterAssignedLoanTapes = filterAssignedLoanTapes;
const filterReceivableResponseTapePreviews = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'receivableResponseTapePreview' });
exports.filterReceivableResponseTapePreviews = filterReceivableResponseTapePreviews;
const filterBorrowingBaseReports = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'borrowingBaseReport' });
exports.filterBorrowingBaseReports = filterBorrowingBaseReports;
const filterGeneratedCashBalanceFeeds = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'generatedCashBalanceFeed' });
exports.filterGeneratedCashBalanceFeeds = filterGeneratedCashBalanceFeeds;
const filterGeneratedRepaymentTapes = (params) => {
    const artifacts = filterArtifactsByType({
        dataTapes: params.dataTapes,
        type: 'generatedRepaymentTape',
    });
    const generatedRepaymentTapes = [];
    for (const artifact of artifacts) {
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordGeneratedRepaymentTape(artifact), `[${artifact.id}] is not "GeneratedRepaymentTape"`);
        generatedRepaymentTapes.push(artifact);
    }
    return generatedRepaymentTapes;
};
exports.filterGeneratedRepaymentTapes = filterGeneratedRepaymentTapes;
const filterAssignedRepaymentTapes = (params) => {
    const artifacts = filterArtifactsByType({
        dataTapes: params.dataTapes,
        type: 'assignedRepaymentTape',
    });
    const assignedRepaymentTapes = [];
    for (const artifact of artifacts) {
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordAssignedRepaymentTape(artifact), `[${artifact.id}] is not "AssignedRepaymentTape"`);
        assignedRepaymentTapes.push(artifact);
    }
    return assignedRepaymentTapes;
};
exports.filterAssignedRepaymentTapes = filterAssignedRepaymentTapes;
const filterInternalRepaymentTapes = (params) => {
    const artifacts = filterArtifactsByType({
        dataTapes: params.dataTapes,
        type: 'internalRepaymentTape',
    });
    const internalRepaymentTapes = [];
    for (const artifact of artifacts) {
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordInternalRepaymentTape(artifact), `[${artifact.id}] is not "InternalRepaymentTape"`);
        internalRepaymentTapes.push(artifact);
    }
    return internalRepaymentTapes;
};
exports.filterInternalRepaymentTapes = filterInternalRepaymentTapes;
const filterCashResponseTapes = (params) => {
    const artifacts = filterArtifactsByType({
        dataTapes: params.dataTapes,
        type: 'cashResponseTape',
    });
    const cashResponseTapes = [];
    for (const artifact of artifacts) {
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordCashResponseTape(artifact), `[${artifact.id}] is not "CashResponseTape"`);
        cashResponseTapes.push(artifact);
    }
    return cashResponseTapes;
};
exports.filterCashResponseTapes = filterCashResponseTapes;
const filterManualBankAccountReports = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'manualBankAccountReport' });
exports.filterManualBankAccountReports = filterManualBankAccountReports;
const filterCashBalancesFeedContexts = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'cashBalancesFeedContext' });
exports.filterCashBalancesFeedContexts = filterCashBalancesFeedContexts;
const filterFundingRequests = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'fundingRequest' });
exports.filterFundingRequests = filterFundingRequests;
const filterApprovalReports = ({ dataTapes, }) => filterArtifactsByType({ dataTapes, type: 'fundingApprovalReport' });
exports.filterApprovalReports = filterApprovalReports;
const getDependenciesByOutputId = ({ outputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.outputArtifactId === outputArtifactId);
    return dependencies;
};
exports.getDependenciesByOutputId = getDependenciesByOutputId;
const getInputTapes = ({ outputArtifactId, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    return (0, exports.getDependenciesByOutputId)({
        outputArtifactId,
        dataTapeDependencies,
    }).map(({ inputArtifactId }) => {
        return (0, exports.findArtifactById)({
            artifactId: inputArtifactId,
            dataTapes,
        });
    });
};
exports.getInputTapes = getInputTapes;
const getAllDependencyInputTapes = ({ outputArtifactId, dbGraph, }) => {
    const inputTapes = (0, exports.getInputTapes)({ outputArtifactId, dbGraph });
    return inputTapes.reduce((acc, inputTape) => {
        acc.push(inputTape);
        const inputTapesForInputTape = (0, exports.getInputTapes)({
            outputArtifactId: inputTape.id,
            dbGraph,
        });
        if (inputTapesForInputTape.length) {
            const inputTapesForInputTapeDependencies = (0, exports.getAllDependencyInputTapes)({
                outputArtifactId: inputTape.id,
                dbGraph,
            });
            inputTapesForInputTapeDependencies.forEach((dependency) => {
                // prevent duplicate dependencies being added if graphs diverged and then remerged
                if (!acc.find(({ id }) => dependency.id === id)) {
                    acc.push(dependency);
                }
            });
        }
        return acc;
    }, []);
};
exports.getAllDependencyInputTapes = getAllDependencyInputTapes;
const getDependenciesByInputId = ({ inputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.inputArtifactId === inputArtifactId);
    return dependencies;
};
exports.getDependenciesByInputId = getDependenciesByInputId;
const getOutputTapes = ({ inputArtifactId, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    return (0, exports.getDependenciesByInputId)({
        inputArtifactId,
        dataTapeDependencies,
    }).map(({ outputArtifactId }) => {
        return (0, exports.findArtifactById)({
            artifactId: outputArtifactId,
            dataTapes,
        });
    });
};
exports.getOutputTapes = getOutputTapes;
const filterUserInputNeededNodesForAssignment = ({ dataTapes, dataTapeDependencies, }) => {
    const allUserInputNeededArtifacts = filterArtifactsByType({
        dataTapes,
        type: 'userInputNeeded',
    });
    return allUserInputNeededArtifacts.filter((artifact) => {
        return (0, exports.getOutputTapes)({
            inputArtifactId: artifact.id,
            dbGraph: { dataTapes, dataTapeDependencies },
        }).some((outputTape) => outputTape.type === 'assignedLoanTape');
    });
};
exports.filterUserInputNeededNodesForAssignment = filterUserInputNeededNodesForAssignment;
const filterUserInputNeededNodesCashBalanceContext = ({ dataTapes, dataTapeDependencies, }) => {
    const allUserInputNeededArtifacts = filterArtifactsByType({
        dataTapes,
        type: 'userInputNeeded',
    });
    return allUserInputNeededArtifacts.filter((artifact) => {
        return (0, exports.getOutputTapes)({
            inputArtifactId: artifact.id,
            dbGraph: { dataTapes, dataTapeDependencies },
        }).some((outputTape) => outputTape.type === 'cashBalancesFeedContext');
    });
};
exports.filterUserInputNeededNodesCashBalanceContext = filterUserInputNeededNodesCashBalanceContext;
const getDependency = ({ outputArtifactId, inputArtifactId, dataTapeDependencies, }) => {
    const dependencies = dataTapeDependencies.filter((dep) => dep.inputArtifactId === inputArtifactId &&
        dep.outputArtifactId === outputArtifactId);
    (0, common_1.finleyAssert)(dependencies.length === 1, 'unable to get dependency');
    return dependencies[0];
};
exports.getDependency = getDependency;
const insertDependency = ({ dataTapeDependency, insertId, }) => {
    const { outputArtifactId, inputArtifactId } = dataTapeDependency;
    const outputDependency = {
        outputArtifactId,
        inputArtifactId: insertId,
    };
    const inputDependency = {
        outputArtifactId: insertId,
        inputArtifactId,
    };
    return { outputDependency, inputDependency };
};
exports.insertDependency = insertDependency;
const removeDependenciesByInputArtifactId = ({ dataTapeDependencies, inputArtifactIds, }) => {
    const inputArtifactIdSet = new Set(inputArtifactIds);
    return (0, remeda_1.filter)(dataTapeDependencies, (dep) => !inputArtifactIdSet.has(dep.inputArtifactId));
};
exports.removeDependenciesByInputArtifactId = removeDependenciesByInputArtifactId;
const removeDependenciesByOutputArtifactId = ({ dataTapeDependencies, outputArtifactIds, }) => {
    const outputArtifactIdSet = new Set(outputArtifactIds);
    return (0, remeda_1.filter)(dataTapeDependencies, (dep) => !outputArtifactIdSet.has(dep.outputArtifactId));
};
exports.removeDependenciesByOutputArtifactId = removeDependenciesByOutputArtifactId;
const removeArtifactsByTypes = ({ dataTapes, types, }) => {
    const artifactTypeSet = new Set(types);
    return (0, remeda_1.filter)(dataTapes, (tape) => !artifactTypeSet.has(tape.type));
};
exports.removeArtifactsByTypes = removeArtifactsByTypes;
const removeDependency = ({ dataTapeDependencies, dependencyToRemove, }) => {
    const res = (0, remeda_1.filter)(dataTapeDependencies, (dep) => !(dep.inputArtifactId === dependencyToRemove.inputArtifactId &&
        dep.outputArtifactId === dependencyToRemove.outputArtifactId));
    (0, common_1.finleyAssert)(dataTapeDependencies.length - res.length === 1, `unable to remove dependency [outputArtifactId:${dependencyToRemove.outputArtifactId}] [inputArtifactId:${dependencyToRemove.inputArtifactId}]`);
    return res;
};
exports.removeDependency = removeDependency;
const removeDependencies = ({ dataTapeDependencies, dependenciesToRemove: _dependenciesToRemove, }) => {
    const dependenciesToRemove = cloneDeep(_dependenciesToRemove);
    if (!dependenciesToRemove.length)
        return dataTapeDependencies;
    const dependencyToRemove = dependenciesToRemove.shift();
    (0, common_1.finleyAssert)(dependencyToRemove, 'dependencyToRemove must exist');
    const deps = (0, exports.removeDependency)({
        dataTapeDependencies,
        dependencyToRemove,
    });
    return (0, exports.removeDependencies)({
        dataTapeDependencies: deps,
        dependenciesToRemove,
    });
};
exports.removeDependencies = removeDependencies;
// asserts that there are no duplicate dependencies in the dataTapeDependencies
// the failures message includes the `artifactSlug => artifactSlug` that was duplicated
const ensureNoDuplicateDependencies = ({ functionName, dbGraph, }) => {
    const { dataTapeDependencies, dataTapes } = dbGraph;
    const dependencies = dataTapeDependencies.map(({ outputArtifactId, inputArtifactId }) => {
        const outputArtifact = (0, exports.findArtifactById)({
            artifactId: outputArtifactId,
            dataTapes,
        });
        const inputArtifact = (0, exports.findArtifactById)({
            artifactId: inputArtifactId,
            dataTapes,
        });
        (0, common_1.finleyAssert)(outputArtifact, `${functionName}: Unable to find outputArtifact for ${outputArtifactId}`);
        (0, common_1.finleyAssert)(inputArtifact, `${functionName}: Unable to find inputArtifact for ${inputArtifactId}`);
        return `${inputArtifact.artifactSlug} => ${outputArtifact.artifactSlug}`;
    });
    // ensure no duplicate dependencies
    dependencies.forEach((dependency) => {
        const count = dependencies.filter((d) => d === dependency).length;
        (0, common_1.finleyAssert)(count === 1, `${functionName}: Duplicate dependency found: ${dependency} (count: ${count})`);
    });
};
exports.ensureNoDuplicateDependencies = ensureNoDuplicateDependencies;
const generateLoanTapeTypeMap = (dataTapes) => {
    const generatedLoanTapes = (0, exports.filterGeneratedLoanTapes)({ dataTapes });
    (0, common_1.finleyAssert)((0, exports.hasLoanProductSlug)(generatedLoanTapes), 'generatedLoanTapes must have loanProductSlug');
    return (0, remeda_1.reduce)(generatedLoanTapes, (acc, tape) => {
        if (acc[tape.loanProductSlug]) {
            (0, common_1.finleyAssert)(acc[tape.loanProductSlug] === tape.configuration.loanTapeType, new common_1.error.FinleyError('loanProduct loanTapeType is configured inconsistently.'));
            return acc;
        }
        (0, common_1.finleyAssert)(finley_types_1.typeguards.loanProduct.isLoanTapeType(tape.configuration.loanTapeType), new common_1.error.FinleyError('loanTapeType must be configured on generated loan tape as valid loanTapeType.'));
        return {
            ...acc,
            [tape.loanProductSlug]: tape.configuration.loanTapeType,
        };
    }, {});
};
exports.generateLoanTapeTypeMap = generateLoanTapeTypeMap;
//# sourceMappingURL=utils.js.map